/**
 * Advertising IDs are only available through native ATT/advertising APIs.
 * Keep web from importing the native ATT package, which requires a native module.
 */
export const getAdDeviceId = async (): Promise<string | undefined> => undefined;
